export default {
  computed: {
    perm() {
      return this.$store.state.perm.perm;
    },
    versions(){
      return 'v1.0.6'
    }
  },
  methods: {
    hasPermi(permission) {
      const all_permission = "*:*:*";
      if (permission && permission.length > 0) {
        return this.perm.some(v => {
          return all_permission === v || v === permission
        })
      } else {
        return false
      }
    },
    hasAllPermi(permission) {
      const all_permission = "*:*:*";
      if (permission && permission.length > 0) {
        return this.perm.every(v => {
          return all_permission === v || v === permission
        })
      } else {
        return false
      }
    }
  }
};
